export const LOADING = 'authLoading';
export const LOGIN = 'authLogin';
export const LOGOUT = 'authLogout';
export const ERROR = 'authError';
export const ME = 'authMe';
